import { Button, Col, Row } from 'antd';
import React from 'react';

const ButtonsOption = ({ question, selectOption }) => {
  const isSelected = (option) => {
    if (Array.isArray(question.selected_option)) {
      return question.selected_option.some(
        (selectedOption) => selectedOption.value === option.value
      );
    }
    return question.selected_option?.value === option.value;
  };

  return (
    <Row justify='center'>
      {
        question.options?.map((option) => {
          return (
            <Col xs={24} sm={12} key={option.value} className='text-center survey-option-column'>
              <Button
                className={`cmt-button survey-option-button ${isSelected(option) ? 'survey-button-selected' : 'survey-button'} outline mt-10 mb-10`}
                type="primary"
                size='large'
                onClick={() => selectOption(question, option)}
              >
                <div className='text-center survey-option-label'>{option.text}</div>
              </Button>
            </Col>
          )
        })
      }
    </Row>
  )
}

export default ButtonsOption;